import { render, staticRenderFns } from "./DynamicBox.vue?vue&type=template&id=681fd846&scoped=true&"
import script from "./DynamicBox.vue?vue&type=script&lang=js&"
export * from "./DynamicBox.vue?vue&type=script&lang=js&"
import style0 from "./DynamicBox.vue?vue&type=style&index=0&id=681fd846&lang=less&scoped=true&"
import style1 from "./DynamicBox.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681fd846",
  null
  
)

export default component.exports